import React, { useEffect } from "react"
import FindVehicleMain from "./FindVehicleMain"

const FindVehicle = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <FindVehicleMain />
    </div>
  )
}

export default FindVehicle
